var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65162 13.2014C12.3384 13.2014 14.5182 10.9558 14.5182 8.18803C14.5182 5.42022 12.3384 3.17465 9.65162 3.17465C6.96489 3.17465 4.78508 5.42022 4.78508 8.18803C4.78508 10.9558 6.96489 13.2014 9.65162 13.2014ZM13.9774 14.3155H12.1153C11.365 14.6706 10.5303 14.8725 9.65162 14.8725C8.77294 14.8725 7.94157 14.6706 7.18794 14.3155H5.32581C2.93648 14.3155 1 16.3104 1 18.7718V19.3289C1 20.2515 1.7266 21 2.62218 21H16.6811C17.5766 21 18.3032 20.2515 18.3032 19.3289V18.7718C18.3032 16.3104 16.3668 14.3155 13.9774 14.3155Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9855 6.34225L22.8302 4.44192C23.0566 4.20872 23.0566 3.83063 22.8302 3.59724L22.4203 3.1749C22.1939 2.9417 21.8269 2.9417 21.6003 3.1749L19.7556 5.07524L17.911 3.1749C17.6846 2.9417 17.3176 2.9417 17.091 3.1749L16.6811 3.59724C16.4547 3.83044 16.4547 4.20853 16.6811 4.44192L18.5257 6.34225L16.6811 8.24259C16.4547 8.47579 16.4547 8.85388 16.6811 9.08727L17.091 9.50961C17.3174 9.74281 17.6846 9.74281 17.911 9.50961L19.7556 7.60927L21.6003 9.50961C21.8267 9.74281 22.1939 9.74281 22.4203 9.50961L22.8302 9.08727C23.0566 8.85407 23.0566 8.47598 22.8302 8.24259L20.9855 6.34225Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersPlus);
export default __webpack_public_path__ + "static/media/users-plus.81bfd43ed7272d78f8a21642de937f0f.svg";
export { ForwardRef as ReactComponent };